import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71c514b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title wow animate__backInDown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { class: "title-text wow animate__backInDown" }
const _hoisted_4 = { class: "table wow animate__backInDown" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "序号"),
    /*#__PURE__*/_createElementVNode("th", null, "岗位"),
    /*#__PURE__*/_createElementVNode("th", null, "招聘人数")
  ])
], -1))
const _hoisted_6 = ["onMouseover", "onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { colspan: "3" }
const _hoisted_9 = { class: "expanded-content" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { key: 0 }

import WOW from 'wow.js'
import { onMounted, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

onMounted(() => {
  new WOW().init()
})
const tableData = [
  {
    id: 1,
    position: '研发工程师',
    count: '2',
    expand: {
      duty: {
        title: '岗位职责',
        content: [
          '1、负责生物医学高分子材料的合成、负责聚合物弹性体的研发;',
          '2、负责与高分子材料相关产品的质量提升以及高分子材料的改性研究;',
          '3、负责研发项目相关文档的编写;',
          '4、协助完成研发主管的其他相关研发工作;'
        ]
      },
      require: {
        title: '岗位要求',
        content: [
          '1、本科以上学历，高分子材料及合成等化学相关的专业;',
          '2、具有独立承担过可降解生物材料、医疗器械等项目经验优先;',
          '3、熟练掌握常规化学实验操作，有较好的分析问题、解决问题的能力;',
          '4、英语六级以上，能够熟练查阅文献，掌握本领域最新研究进展;',
          '5、身心健康，善于沟通，思维活跃，具有良好的团队合作精神，具备一定的团队管理能力;',
          '6、完成上级安排的其他任务;'
        ]
      }
    }
  }, {
    id: 2,
    position: '注册法规专员',
    count: '2',
    expand: {
      duty: {
        title: '岗位职责',
        content: [
          '1、负责保健食品及食品产品准入工作：按照法规要求，负责保健品食品注册、备案、变更、转让及再注册维护的准确，及时，有序开展;',
          '2、跟进工厂保健食品的注册及备案（生产、稽核、实验数据、审批环节）各环节，及时汇报异常情况，并落实情况及时处理;',
          '3、熟悉国内食品政策法规，收集国外食品政策法规（尤其一带一路国家），负责公司国内外产品的注册工作;',
          '4、日常工作总结，食品注册方法的优化、流程建立，定期对日常工作进行总结及改进;'
        ]
      },
      require: {
        title: '岗位要求',
        content: [
          '1、本科及以上学历，药学，生物，化学，营养学，食品相关专业;',
          '2、熟悉保健食品或药品行业注册法规，2年及以上相关行业工作经验尤佳;',
          '3、有较强的沟通协调能力，文字表达能力优秀，英语良好'
        ]
      },
      walfare: {
        title: '薪资福利',
        content: [
          '1、五天八小时工作时间制，优于行业薪酬;',
          '2、年终奖;',
          '3、五险一金∶入职即享受国家规定的养老保险、基本医疗保险、工伤保险、失业保险、女职工生育保险，住房公积金;',
          '4、各种假期∶带薪年假、国家法定节假日、婚假、丧假、产假等;',
          '5、快乐活动∶中秋博饼、尾牙宴活动、公司周年庆活动，生日会，下午茶，不定期团队活动;'

        ]
      }
    }
  }, {
    id: 3,
    position: '医疗器械注册专员',
    count: '1',
    expand: {
      duty: {
        title: '岗位职责',
        content: [
          '1、负责医疗器械产品注册流程及产品注册资料编号与申报;',
          '2、了解医疗器械相关产品标准及医疗器械行业的其他相关标准;',
          '3、协助编写医疗器械产品技术文件;',
          '4、配合上级主管进行医疗公司质量管理体系建设及推进;'
        ]
      },
      require: {
        title: '岗位要求',
        content: [
          '1、医疗/医学/化学/生物专业工作或教育背景，熟悉二类、三类医疗器械注册流程;',
          '2、有良好的沟通技巧和协调能力;',
          '3、熟悉医疗器械行业相关法律法规、政策，熟悉政府部门的工作流程;',
          '4、有质量体系认证/国外医疗器械产品注册工作经验优先考虑;'
        ]
      }
    }
  }, {
    id: 4,
    position: '研发总监（医疗器械）',
    count: '1',
    expand: {
      duty: {
        title: '岗位职责',
        content: [
          '1、全权负责研发部门各项工作;',
          '2、制定公司研发产品计划，带领研发团队完成研发任务;',
          '3、 建立高效的产品开发流程，对研发过程进行有效的监督和控制;',
          '4、 负责研发过程中疑难问题的攻关，指导研发人员开展工作;',
          '5、 定期向董事长汇报所分管的工作，并完成其交办的其它工作;'
        ]
      },
      require: {
        title: '岗位要求',
        content: [
          '1、 硕士及以上学历，有医疗器械研发相关专业（医疗器械、生物医学工程、机械、电子、医学、生物工程、化学、药学、护理学、康复、检验学、管理等专业），3年以上医疗器械产品研发经验，2年研发团队管理经验;',
          '2、 具备较强的解决研发技术问题的综合能力;',
          '3、 有成功的项目申报及取得项目文号工作经验的优先;',
          '4、 有较强的团队合作精神和沟通协调能力;',
        ]
      },
      walfare: {
        title: '薪资福利',
        content: [
          '1、公司协助办理政府生活补贴、人才公寓、购房补贴、落户等;',
          '2、月薪+绩效奖励+项目奖励+年终奖，五险一金，五天八小时工作时间制;',
          '3、带薪婚假、年假、产假、陪产假等;',
          '4、节假日福利、办公室不限量零食包，不定期团建活动等;'
        ]
      }
    }
  }, {
    id: 5,
    position: '研发经理（美瞳方向）',
    count: '1',
    expand: {
      duty: {
        title: '岗位职责',
        content: [
          '1、负责隐形眼镜，美瞳等产品的设计与开发;',
          '2、对产品的开发评估和导入量产时程规划;',
          '3、对产品进行持续优化，持续设计并跟进实施;',
          '4、实验报告分析和问题解决，问题解决;',
          '5、配合筹建美瞳研发部门及部门人员管理。'
        ]
      },
      require: {
        title: '岗位要求',
        content: [
          '1、本科及以上学历，药学，生物，化学，营养学，食品相关专业;',
          '2、熟悉保健食品或药品行业注册法规，2年及以上相关行业工作经验尤佳;',
          '3、有较强的沟通协调能力，文字表达能力优秀，英语良好'
        ]
      },
      walfare: {
        title: '薪资福利',
        content: [
          '1、本科以上学历，高分子材料、化工、生物材料相关教育背景。有高分子/化工材料合成经验或2年以上医疗器械（美瞳、隐形眼镜）产品研发工作经验。有研发团队组建或带团队经验，熟悉研发管理流程;',
          '2、有产品开发与验证经验;',
          '3、有医疗器械相关法规与风险管理经验;'
        ]
      }
    }
  }
]
const highlightedRow = ref(null)
const clickRow = ref(null)
const expandedRow = ref(null)

const highlightRow = (index) => {
  highlightedRow.value = index
}

const resetRowHighlight = () => {
  highlightedRow.value = null
}

const toggleRow = (index) => {
  expandedRow.value = (expandedRow.value === index) ? null : index
  clickRow.value = (clickRow.value === index) ? null : index
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('recruittitle2')), 1),
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('recruittitle1')), 1),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('recruittext1')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('recruittext2')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", null, [
        _hoisted_5,
        _createElementVNode("tbody", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableData, (row, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createElementVNode("tr", {
                onMouseover: ($event: any) => (highlightRow(index)),
                onMouseout: resetRowHighlight,
                onClick: ($event: any) => (toggleRow(index)),
                class: _normalizeClass({ 'highlighted': highlightedRow.value === index || clickRow.value === index })
              }, [
                _createElementVNode("td", null, _toDisplayString(row.id), 1),
                _createElementVNode("td", null, _toDisplayString(row.position), 1),
                _createElementVNode("td", null, _toDisplayString(row.count), 1)
              ], 42, _hoisted_6),
              (expandedRow.value === index)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _createElementVNode("td", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("h4", null, _toDisplayString(row.expand.duty.title) + ": ", 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.expand.duty.content, (item) => {
                            return (_openBlock(), _createElementBlock("span", { key: item }, _toDisplayString(item), 1))
                          }), 128)),
                          _createElementVNode("h4", null, _toDisplayString(row.expand.require.title), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.expand.require.content, (item) => {
                            return (_openBlock(), _createElementBlock("span", { key: item }, _toDisplayString(item), 1))
                          }), 128)),
                          (row.expand.walfare)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("h4", null, _toDisplayString(row.expand.walfare.title), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.expand.walfare.content, (item) => {
                                  return (_openBlock(), _createElementBlock("span", { key: item }, _toDisplayString(item), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 64))
        ])
      ])
    ])
  ], 64))
}
}

})